






import ApiConfiguration from '@/classes/ApiConfiguration';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { Base64Utils } from '@/utils';
import Vue, { PropType } from 'vue';
import LoadingSpinner from '../shared/LoadingSpinner.vue';

export default Vue.extend({
  props: {
    linkData: {
      required: true,
      type: Object as PropType<{ success: boolean; notification: string; id: number; backgroundPrintId: number }>
    },
    actionIsDelete: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    async printDocument(this: any) {
      this.isLoading = true;
      try {
        const base64 = await ApiConfiguration.api().documentPrint.documentPrintBackgroundprintDetail(this.linkData.backgroundPrintId);
        if (!base64) {
          SnotifyConfiguration.showInformation('Document is no longer available for printing, please queue for printing again');
          this.isLoading = false;
          return;
        }
        const fileUrl = Base64Utils.previewBase64(base64!, null);
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        iframe.style.visibility = 'hidden';
        iframe.src = fileUrl;

        iframe.onload = () => {
          iframe.contentWindow?.print();
          URL.revokeObjectURL(fileUrl);
          this.isLoading = false;
        };

        document.body.appendChild(iframe);
      } finally {
        this.$emit('link-action:completed');
      }
    },
    async deleteDocument(this: any) {
      try {
        await ApiConfiguration.api().documentPrint.documentPrintBackgroundprintDelete(this.linkData.id);
      } catch (error) {
        this.$log(error);
      }

      this.$emit('link-action:completed');
    }
  },
  async mounted() {
    if (this.actionIsDelete) {
      await this.deleteDocument();
      return;
    }
    this.printDocument();
  },
  components: { LoadingSpinner }
});
